module.exports = __webpack_public_path__ + "static/media/green_label_desktop.1fcc3dee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/backgrounds/green_label_desktop.jpg
// module id = 519
// module chunks = 0